import React, { Component } from 'react';
import { Flex, Box } from 'reflexbox';
import PropTypes from 'prop-types';
import ButtonLink from 'components/ButtonLink';
import EmergencyMessage from 'components/EmergencyMessage';

import Text from 'components/Text';

// Styles
import './noProducts.styles.scss';

import imgEmpty from 'images/ill-alien.svg';

export default class NoProducts extends Component {
    render() {
        const { isUserLogged } = this.props;
        return (
            <Flex wrap className="noproducts">
                <EmergencyMessage />
                <Box w={1} className="noproducts__image" flex justify="center">
                    <img src={imgEmpty} alt="" />
                </Box>
                <Box w={1} py={2} className="noproducts__text">
                    <p><Text textKey="product_list_no_products_1" /></p>
                    <p><Text textKey="product_list_no_products_2" /></p>
                    {!isUserLogged && window.Checkout.settings.profile.enable &&
                        <Box mt={3}>
                            <a href={window.Checkout.settings.profile.create_profile_url}>
                                <Text textKey="product_list_profile_promo_create_label" />
                            </a>
                        </Box>
                    }
                    <Flex className="noproducts__options" justify="center" mt={3}>
                        <Box w={1 / 2}>
                            <ButtonLink
                                theme="primary"
                                text="product_list_no_product_browse"
                                to={window.Checkout.settings.catalog_browse_link}
                            />
                        </Box>
                        {!isUserLogged && window.Checkout.settings.profile.enable &&
                            <Box w={1 / 2}>
                                <ButtonLink
                                    theme="primary"
                                    to={window.Checkout.settings.profile.login_url
                                        ? window.Checkout.settings.profile.login_url + window.location.href
                                        : {
                                            pathname: '/' + window.Checkout.settings.locale_url + '/checkout/login/',
                                            search: 'backurl=/' + window.Checkout.settings.locale_url + '/checkout/shoppinglist/',
                                        }
                                    }
                                    text="product_list_no_product_login_label"
                                />
                            </Box>
                        }
                    </Flex>
                </Box>
            </Flex>
        );
    }
}

NoProducts.propTypes = {
    isUserLogged: PropTypes.bool,
};
